import { createAction, props } from '@ngrx/store';
import { Config, ConfigEditorDetailVariant } from '../domain/config';

const feature = '[CXB Config editor Screen]';

export const loadCxbConfigEntries = createAction(`${feature} Load config entries`);
export const loadCxbConfigEntriesSuccess = createAction(`${feature} Load config entries success`, props<{ configs: Config[] }>());
export const loadCxbConfigEntriesFail = createAction(`${feature} Load config entries fail`, props<{ errorMessage: string }>());

export const loadCxbConfigEntry = createAction(`${feature} Load config entry`, props<{ key: string }>());
export const loadCxbConfigEntrySuccess = createAction(
  `${feature} Load config entry success`,
  props<{ config: Config; variant: ConfigEditorDetailVariant }>()
);
export const loadCxbConfigEntryFail = createAction(`${feature} Load config entry fail`, props<{ errorMessage: string }>());

export const leaveConfigEditorDetailScreen = createAction(`${feature} Leave config editor detail screen`);

export const createCxbConfigEntry = createAction(`${feature} Create config entry`, props<{ config: Config }>());
export const createCxbConfigEntrySuccess = createAction(`${feature} Create config entry success`, props<{ key: string }>());
export const createCxbConfigEntryFail = createAction(`${feature} Create config entry fail`, props<{ errorMessage: string }>());

export const updateCxbConfigEntry = createAction(`${feature} Update config entry`, props<{ config: Config }>());
export const updateCxbConfigEntrySuccess = createAction(`${feature} Update config entry success`, props<{ key: string }>());
export const updateCxbConfigEntryFail = createAction(`${feature} Update config entry fail`, props<{ errorMessage: string }>());

export const deleteCxbConfigEntry = createAction(`${feature} Delete config entry`, props<{ key: string }>());
export const deleteCxbConfigEntrySuccess = createAction(`${feature} Delete config entry success`, props<{ key: string }>());
export const deleteCxbConfigEntryFail = createAction(`${feature} Delete config entry fail`, props<{ errorMessage: string }>());
